import { render, staticRenderFns } from "./company-quote-info.vue?vue&type=template&id=3b1a0970&scoped=true&"
import script from "./company-quote-info.vue?vue&type=script&lang=js&"
export * from "./company-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./company-quote-info.vue?vue&type=style&index=0&id=3b1a0970&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a0970",
  null
  
)

export default component.exports